import React, { memo, ReactNode, useState } from 'react';

import { areEqual } from 'Utils/equalityChecks';
import { width } from 'Utils/screen';
import { Tab } from 'Components/Tabs/Tab';
import classes from './rocketPayTabs.module.css';

interface Props {
  id?: string;
  className?: string;
  children?: ReactNode;
  onTabChange?: (tabId: string) => void;
}

const createTabs = (activeTab: string, onTabClick: (e: any) => void) => (
  <>
    <Tab
      key="payments-tab"
      id="payments-tab"
      className={`${classes.flexCenter} ${classes.button} ${
        activeTab === 'payments-tab' ? `active ${classes['active-Tab']}` : ''
      }`}
      target="rocketpaypayments"
      onClick={onTabClick}
    >
      <span>Payments</span>
    </Tab>
    <Tab
      key="payouts-tab"
      id="payouts-tab"
      className={`${classes.flexCenter} ${classes.button} ${
        activeTab === 'payouts-tab' ? `active ${classes['active-Tab']}` : ''
      }`}
      target="rocketpaypayouts"
      onClick={onTabClick}
    >
      <span>Payouts</span>
    </Tab>
    <Tab
      key="pending-tab"
      id="pending-tab"
      className={`${classes.flexCenter} ${classes.button} ${
        activeTab === 'pending-tab' ? `active ${classes['active-Tab']}` : ''
      }`}
      target="rocketpaypending"
      onClick={onTabClick}
    >
      <span>Pending</span>
    </Tab>
    <Tab
      key="status-tab"
      id="status-tab"
      className={`${classes.flexCenter} ${classes.button} ${
        activeTab === 'status-tab' ? `active ${classes['active-Tab']}` : ''
      }`}
      target="rocketpaystatus"
      onClick={onTabClick}
    >
      <span>Status</span>
    </Tab>
    <Tab
      key="report-tab"
      id="report-tab"
      className={`${classes.flexCenter} ${classes.button} ${
        activeTab === 'report-tab' ? `active ${classes['active-Tab']}` : ''
      }`}
      target="rocketpayreport"
      onClick={onTabClick}
    >
      <span>Report</span>
    </Tab>
  </>
);

/*
  In order to override bootstraps active class on tabs, there is a click event onTabClick, which will get the name of the tab that was clicked
  and then trigger a re-render.  Note in the createTabs method above, where the active class is added or not, based on which tab was clicked.
*/
function RocketPayTabs({ id = 'tabs', className, children, onTabChange }: Props) {
  // We want to set the initial active tab to the first tab in the incoming tabList
  const [activeTab, setActiveTab] = useState('payments-tab');

  const onTabClick = (e: any) => {
    // Occasionally, e.currentTarget is undefined.  Set the current activeTab if we run into this bug
    const nextTab = e?.currentTarget?.id || activeTab;
    setActiveTab(nextTab);
    onTabChange?.(nextTab);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <div className={classes.tabContainerWrapper}>
            <div className={classes.tabsContainer}>
              <ul
                className={`nav nav-tabs ${width < 576 ? 'flex-sm-column' : 'width'}   ${classes.tabs} ${
                  className || ''
                }`}
                id={id}
                role="tablist"
              >
                {createTabs(activeTab, onTabClick)}
              </ul>
            </div>
            <div className="tab-content w-100 h-100 d-inline-block" id="rocketpayTabContent" style={{ height: 'auto' }}>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

RocketPayTabs.defaultProps = {
  id: undefined,
  className: undefined,
  children: undefined,
  onTabChange: undefined,
};
const RocketPayTabsMemo = memo(RocketPayTabs, areEqual);
export { RocketPayTabsMemo as RocketPayTabs };
